import { api } from "../ModuloGerenciador/UrlPadrao";

export type IaResponse = {
  resposta?: string;
  v?: string;
};

export type EncontrarVeiculoRequest = {
  eixos?: number | null;
  pedidoId: number;
  destinatarioId?: number | null;
  tipoCarroceriaId?: number | null;
  previsaoEmbarque: Date;
  versao: number;
};

export type VeiculoResponse = {
  texto: string;
  idVeiculo: number;
  placa: string;
  telefoneMotorista: string;
  telefoneProprietario: string;
};

export type EncontrarVeiculoResponse = {
  veiculos: VeiculoResponse[];
};

export const getIaResumoViagem = async ({
  token,
  identificadorViagem
}: { token: string; identificadorViagem: string }) => {
  return api.get<IaResponse>(`ia/prompt/${identificadorViagem}`, {
    headers: {
      Authorization: token,
    },
  });
};

export const getIaLocalizacaoConjunto = async ({
  token,
  placa
}: { token: string; placa: string }) => {
  return api.get<IaResponse>(`ia/prompt/conjunto/${placa}`, {
    headers: {
      Authorization: token,
    },
  });
};

export const postIaLegislacao = async ({
  token,
  pergunta
}: { token: string; pergunta: string }) => {
  return api.post<IaResponse>(
    "ia/legislacao",
    { pergunta },
    {
      headers: {
        Authorization: token,
      },
    }
  );
};

export const postEncontrarVeiculo = async ({
  token,
  payload,
}: { token: string; payload: EncontrarVeiculoRequest }) => {
  return api.post<EncontrarVeiculoResponse>("ia/prompt/encontrar-veiculo", payload, {
    headers: {
      Authorization: token,
    },
  });
};

export const getDetalhesVeiculo = async ({
  token,
  idVeiculo,
  versao,
}: { token: string; idVeiculo: number; versao: number }): Promise<{ data: { resposta: string } }> => {
  return api.get(`ia/prompt/veiculo-detalhes/${idVeiculo}/${versao}`, {
    headers: {
      Authorization: token,
    },
  });
};